import { defineStore } from 'pinia'
import { ref } from 'vue'
import xardsService from '../services/xardsService'
import dayjs from 'dayjs'
import { LINK_CATEGORY_ID } from '../constants'

function xardPinCategoryIdFor(xard) {
  if (xard.mapCategoryId?.length) {
    return parseInt(xard.mapCategoryId)
  } else if (!xard.mainCategoryId && xard.itemType === 'webLink') {
    return LINK_CATEGORY_ID
  }
  return xard.mainCategoryId
}

export const useXardsStore = defineStore('xards', () => {
  const xards = ref([])
  const activeStreamFilter = ref({})
  const isSelectionModeActive = ref(false)
  const selectedXards = ref([])

  async function loadXards(options = {}) {
    const page = options.page || 1
    const filters = options.filters
    try {
      const result = await xardsService.all({ page, filters })
      const newXards = result.xards.map(xard => {
        const releasedAt = dayjs(xard.releasedAt)
        const isNew = xard.releasedAt
          ? releasedAt >= dayjs().subtract(1, 'month') && releasedAt <= dayjs().add(1, 'month')
          : false
        const isTrend = xard.lastToppedAt ? dayjs(xard.lastToppedAt) >= dayjs().add('3', 'weeks') : false
        const isFlopTrend = xard.lastFloppedAt
          ? dayjs(xard.lastFloppedAt) >= dayjs().add('3', 'weeks')
          : false

        return {
          ...xard,
          ...{
            isNew,
            isTrend,
            isFlopTrend,
            xardPinCategoryId: xardPinCategoryIdFor(xard)
          }
        }
      })
      activeStreamFilter.value = result.activeStreamFilter
      if (page === 1) {
        xards.value = newXards
      } else {
        xards.value = [...xards.value, ...newXards]
      }
    } catch (error) {
      console.error('Error while fetching xards:', error)
    }
  }

  async function loadLasts(options = {}) {
    const page = options.page || 1
    const query = options.query
    if (page === 1) {
      xards.value = []
    }
    try {
      const result = await xardsService.last({ page, query })
      const newXards = result.xards.map(xard => {
        const releasedAt = dayjs(xard.releasedAt)
        const isNew = xard.releasedAt
          ? releasedAt >= dayjs().subtract(1, 'month') && releasedAt <= dayjs().add(1, 'month')
          : false
        const isTrend = xard.lastToppedAt ? dayjs(xard.lastToppedAt) >= dayjs().add('3', 'weeks') : false
        const isFlopTrend = xard.lastFloppedAt
          ? dayjs(xard.lastFloppedAt) >= dayjs().add('3', 'weeks')
          : false

        return {
          ...xard,
          ...{
            isNew,
            isTrend,
            isFlopTrend,
            xardPinCategoryId: xardPinCategoryIdFor(xard)
          }
        }
      })
      activeStreamFilter.value = result.activeStreamFilter
      if (page === 1) {
        xards.value = newXards
      } else {
        xards.value = [...xards.value, ...newXards]
      }
    } catch (error) {
      console.error('Error while fetching xards:', error)
    }
  }

  return { xards, activeStreamFilter, isSelectionModeActive, selectedXards, loadXards, loadLasts }
})
